export const loadingConstants = {
  LOADING_STARTED: "LOADING_STARTED",
  LOADING_COMPLETED: "LOADING_COMPLETE"
};